import useRouter from "@casino/legacy/client/hooks/router/useRouter";
import { getCookie, removeCookie, setCookie } from "@workspace/cookies/browser";
import { useCallback } from "react";

const socialAuthLocaleKey = "social_auth_locale";

const useSocialAuthLocale = () => {
  const { locale: routerLocale } = useRouter();

  const get = useCallback(() => getCookie(socialAuthLocaleKey) as string, []);

  const set = useCallback(
    (socialAuthLocale = routerLocale) => {
      setCookie(socialAuthLocaleKey, socialAuthLocale, {
        expires: inFiveMinutes(),
      });
    },
    [routerLocale],
  );

  const clear = useCallback(() => {
    removeCookie(socialAuthLocaleKey);
  }, []);

  const inFiveMinutes = () => new Date(Date.now() + 300000);

  return [get, set, clear] as const;
};

export default useSocialAuthLocale;
